import React from 'react';
import {View, Platform, StyleSheet, ViewStyle} from 'react-native';

// Define types for the props
interface CircleProps {
  size?: number;
  color?: string;
  blurAmount?: number;
  x?: number;
  y?: number;
  opacity?: number;
  zIndex?: number;
  width?: number;
  height?: number;
}

const Circle: React.FC<CircleProps> = ({
  size = 100,
  width = size,
  height = size,
  color = 'blue',
  blurAmount = 30,
  x = 0,
  y = 0,
  opacity = 1,
  zIndex = 1,
}) => {
  const circleStyle: ViewStyle = {
    width: width,
    height: height,
    borderRadius: '100%',
    backgroundColor: color,
    position: 'absolute',
    top: `${y}%`,
    left: `${x}%`,
    zIndex,
    opacity,
  };

  if (Platform.OS === 'web') {
    circleStyle.filter = `blur(${blurAmount}px)`;
    circleStyle.transform = `translate(${-size / 2}px, ${-size / 2}px)`;
    circleStyle.transition = 'all ease-in-out .8s';
  }

  return <View style={circleStyle} />;
};

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default Circle;
